import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useShortFromPropsOrParams } from '../shortContentHooks';
import { VideoRecommendationsForLearningContent } from '../../recommendations/components/VideoRecommendationsForLearningContent';
import { ShortContentFullToolRecommendations, useGetToolRecommendations } from '../../toolRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentCompletedVideoView = ({
  shortId
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  const {
    short
  } = useShortFromPropsOrParams({
    shortId
  });
  const {
    contentId,
    language,
    name = '',
    useCases = []
  } = short || {};
  const toolRecommendations = useGetToolRecommendations(useCases);
  return contentId && short ? /*#__PURE__*/_jsx(VideoRecommendationsForLearningContent, {
    id: contentId,
    language: language,
    moreTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shortContent.moreTitle"
    }),
    render: recommendationsContent => isDesktop && toolRecommendations ? /*#__PURE__*/_jsx(ShortContentFullToolRecommendations, {
      contentName: name,
      useCases: useCases
    }) : recommendationsContent,
    type: "SHORT_FORM_CONTENT"
  }) : null;
};
export default ShortContentCompletedVideoView;